import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RopGoodsClassifier } from "../../api/models/rop-goods-classifier";
import { ApiError } from "../../app/types";
import { RopGoodsClassifiersApi } from "../../api";
import { AxiosError } from "axios";
import { serializeError } from "../../app/helpers";
import { RootState } from "../../app/store";

export interface RopGoodsClassifierState {
    classifiers: RopGoodsClassifier[];
    status: "idle" | "loading" | "failed";
    error?: ApiError;
}

const initialState: RopGoodsClassifierState = {
    classifiers: [],
    status: "idle",
};

export const fetchRopGoodClassifiersAsync = createAsyncThunk(
    "ropGoodClassifiers/fetch", async (_, { rejectWithValue }) => {
        try {
            const classifierApi = new RopGoodsClassifiersApi();
            const response = await classifierApi.ropGoodsClassifiersControllerFindAll();
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    });

const createExtraReducers = () => {
    const fetchRopGoodClassifiers = () => {
        const { pending, fulfilled, rejected } = fetchRopGoodClassifiersAsync;
        return {
            [`${pending}`]: (state: RopGoodsClassifierState) => {
                console.log("test" + state);
                state.status = "loading";
            },
            [`${fulfilled}`]: (state: RopGoodsClassifierState, action: PayloadAction<RopGoodsClassifier[]>) => {
                state.classifiers = action.payload;
                state.status = "idle";
            },
            [`${rejected}`]: (state: RopGoodsClassifierState, action: PayloadAction<AxiosError>) => {
                const error = serializeError(action.payload);
                state.status = "failed";
                state.error = error;
            },
        };
    };

    return { ...fetchRopGoodClassifiers()};
}

export const ropGoodClassifiersSlice = createSlice({
    name: "ropGoodClassifiers",
    initialState,
    reducers: {},
    extraReducers: createExtraReducers(),
  });

  export const selectRopGoodQualifiers = (state: RootState) => state.ropGoodsClassifiers.classifiers;
  
  export default ropGoodClassifiersSlice.reducer;
